import { Component } from '@angular/core';
import { IconoirInfoCircle } from '@ey-xd/motif-icon';
import { MotifModule } from "@ey-xd/motif-wc-angular";
import { MotifProgressIndicator, MotifProgressIndicatorStep } from "@ey-xd/motif-wc-angular"; 
@Component({
  selector: 'app-coa-instructions',
  standalone: true,
  imports: [MotifModule],
  templateUrl: './coa-instructions.component.html',
  styleUrl: './coa-instructions.component.scss',
})
export class CoAInstructionsComponent {
  IconoirInfoCircle = IconoirInfoCircle;
}
